import React from 'react'
import { Pane, Text } from 'evergreen-ui'

const StatusRegister_12 = ({ DataRegister }) => {
  return (
    <Pane
      fontWeight={700}
      backgroundColor="#ff0000"
      height="100%"
      paddingY={4}
      paddingX={5}
      fontSize={16}
      fontFamily=""
      display="flex" alignItems="center" justifyContent="center" flexDirection="column"
    >
      <Text
        color="#ffffff"
        height="100%"
        paddingY={4}
        paddingX={5}
        fontSize={16}
        fontFamily=""
      >
        ไม่ผ่านเกณฑ์การสมัคร
      </Text>
      <Text
        color="#ffffff"
        height="100%"
        paddingY={4}
        paddingX={5}
        fontSize={16}
        fontFamily=""
      >
        ติดต่องานรับสมัครนักศึกษา โทร 055-706-547 
      </Text>
    </Pane>
  )
}

export default StatusRegister_12